import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';
import { Key, IEntityResolver } from '@kpd/framework-ngx';

@Injectable()
export class UserEntityResolver implements IEntityResolver<User> {
  constructor(private userService: UserService) {}

  resolve(params: { id: string }): Observable<User> {
    if (params.id === '0') {
      return of(new User());
    }
    return this.userService.getById(Key.composeKeyByRouteParams(params) as Key<string>);
  }
}
